import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ExamTopicTree from './ExamTopicTree';
import PracticeSetsModal from './PracticeSets/PracticeSetsModal';
import StudentVouchersModal from './StudentVoucherComponent/StudentVouchersModal';
import './Dashboard.css';
import './ExamTopicTree.css';
import Button from '@mui/material/Button';


function UpcomingExams({ studentId, selectedVoucher }) { // ✅ added selectedVoucher prop
  const navigate = useNavigate();

  const [selection, setSelection] = useState({
    examId: '',
    examName: '',
    subjectId: '',
    subjectName: '',
    topicId: '',
    topicName: ''
  });

  const [practiceModalOpen, setPracticeModalOpen] = useState(false);
  const [selectedNode, setSelectedNode] = useState(null);
  
  // Trigger re-render of ExamTopicTree when vouchers are activated
  const [refreshCounter, setRefreshCounter] = useState(0);

  // Track whether exams exist
  const [hasExams, setHasExams] = useState(false);

  const [loadTree, setLoadTree] = useState(false); // triggers ExamTopicTree fetch

  // ✅ useEffect to reload tree when selectedVoucher changes
  useEffect(() => {
    if (selectedVoucher) {
      console.log("UpcomingExams received voucher:", selectedVoucher);
      setHasExams(false); // reset exam availability while tree reloads
      setLoadTree(prev => !prev); // toggle to trigger ExamTopicTree
    }
  }, [selectedVoucher]);

  const [currentVoucher, setCurrentVoucher] = useState(selectedVoucher);

useEffect(() => {
  // If parent changes selectedVoucher, update internal state
  setCurrentVoucher(selectedVoucher);
}, [selectedVoucher]);


  const handleSelectionChange = (newSelection) => {
    setSelection(newSelection);
  };

  const handleOpenPracticeModal = (ids) => {
    setSelectedNode(ids); // { examId, subjectId, topicId }
    setPracticeModalOpen(true);
  };

  const handleVoucherActivated = () => {
    setRefreshCounter(prev => prev + 1); // forces ExamTopicTree to re-fetch active exams
  };

  // Optional: control StudentVouchersModal visibility
  const [voucherModalOpen, setVoucherModalOpen] = useState(false);



  return (
    <div className="upcomingExamSection">
      <h2 className="sectionTitle">📅 Upcoming Exams</h2>
<Button
  variant="outlined"
  color="secondary"
  size="small"
  onClick={() => setVoucherModalOpen(true)}
  sx={{ mb: 2, borderRadius: '999px', textTransform: 'none' }}
>
  Switch Exam
</Button>

      {/* Exam Tree */}
      <ExamTopicTree
        studentId={studentId}
        onSelectionChange={handleSelectionChange}
        onPracticeClick={handleOpenPracticeModal}
        refresh={refreshCounter}
        onExamsLoaded={(count) => setHasExams(count > 0)}  //update exam availability
       // voucher={selectedVoucher}
        voucher={currentVoucher}  
        loadTreeTrigger={loadTree}  //pass trigger
      />

      {/* Practice Sets Modal */}
      {practiceModalOpen && selectedNode && (
        <PracticeSetsModal
          open={practiceModalOpen}
          onClose={() => setPracticeModalOpen(false)}
          examId={selectedNode.examId}
          subjectId={selectedNode.subjectId}
          topicId={selectedNode.topicId}
          voucherId={selectedNode.voucherId}   // ✅ Pass voucherId
          voucher={selectedVoucher}
        />
      )}

      {/* Student Vouchers Modal */}
      {voucherModalOpen && (
        <StudentVouchersModal
          studentId={studentId}
          visible={voucherModalOpen}
          onClose={() => setVoucherModalOpen(false)}
          onVoucherActivated={handleVoucherActivated}
          //onSetExam={() => { }} // handled by Dashboard, no change needed here
            onSetExam={(voucher) => {
    console.log("Set Exam clicked:", voucher);
    setCurrentVoucher(voucher);        // ✅ update currentVoucher
    setVoucherModalOpen(false);        // close modal
    setLoadTree(prev => !prev);        // trigger ExamTopicTree reload
  }}
        />
      )}

      {/* Message if no exams */}
      {!hasExams && (
        <p style={{ fontSize: '0.9rem', color: 'gray' }}>
          No upcoming exams available. Please activate a voucher to unlock exams.
        </p>
      )}
    </div>
  );
}

export default UpcomingExams;
